import { graphql } from '@/generated/gql';

export const INTAKE_SUPPLIER_SELECTION = graphql(/* GraphQL */ `
  query IntakeSupplierContact($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        variant
        suppliers {
          id
          internalId
          isQuoted
          source
          reason
          contact {
            firstName
            lastName
            email
            internalId
            language
          }
          location {
            address
            city
            countryCode
            internalId
            postalCode
          }
        }
        requirementsExtraction {
          id
          extractedData
          enhancedData
          processingStatus
        }
      }
    }
  }
`);
